import { render, staticRenderFns } from "./Fashion.vue?vue&type=template&id=990fa79e&scoped=true"
import script from "./Fashion.vue?vue&type=script&setup=true&lang=js"
export * from "./Fashion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Fashion.vue?vue&type=style&index=0&id=990fa79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990fa79e",
  null
  
)

export default component.exports